const MuiMenu = {
  styleOverrides: {
    list: ({
      theme
    }) => ({
      padding: theme.spacing(1, 0)
    })
  }
};
export default MuiMenu;